import { css } from 'styled-components';
export const buttonBorderColorMixin = css`
  border: ${({
  disabled,
  inactive,
  disabledBorderColor,
  borderColor
}) => /* prettier-ignore */
disabled && !inactive ? disabledBorderColor ? `1px solid ${disabledBorderColor}` : 'none' : borderColor ? `1px solid ${borderColor}` : 'none'};

  ${({
  inactive,
  disabled,
  $hasTouch,
  hoverBorderColor,
  focusBorderColor
}) => !inactive && !disabled && !$hasTouch && `
      &:hover {
        ${hoverBorderColor ? `border: 1px solid ${hoverBorderColor};` : ''}
      }
      &:focus {
        ${focusBorderColor ? `border: 1px solid ${focusBorderColor};` : ''}
      }
    `}
  ${({
  inactive,
  disabled,
  activeBorderColor
}) => !inactive && !disabled && `
      &:active {
        ${activeBorderColor ? `border: 1px solid ${activeBorderColor};` : ''}
      }
    `}
`;
export const buttonBorderColorKeys = ['borderColor', 'hoverBorderColor', 'activeBorderColor', 'focusBorderColor', 'disabledBorderColor'];